import { render, staticRenderFns } from "./branchesDataTable.vue?vue&type=template&id=0f6bfd82&scoped=true&"
import script from "./branchesDataTable.vue?vue&type=script&lang=js&"
export * from "./branchesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./branchesDataTable.vue?vue&type=style&index=0&id=0f6bfd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6bfd82",
  null
  
)

export default component.exports